import React, { useEffect, useState } from 'react';
import DoneIcon from '@material-ui/icons/Done';
import DeleteIcon from '@material-ui/icons/Delete';
import UploadIcon from '@material-ui/icons/CloudUpload';
import { makeStyles } from '@material-ui/core/styles';
import {
	CssBaseline,
	Container,
	Paper,
	Typography,
	Button,
	TextField,
	List,
	ListItem,
	ListItemText,
	ListItemSecondaryAction,
	Grid,
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import { Helmet } from 'react-helmet-async';
import { useNavigate, useParams } from 'react-router-dom';
import {
	useGetActorsQuery,
	useGetAuthorsQuery,
	useGetCategoriesQuery,
	useAddCategoryMutation,
	useAddAuthorMutation,
	useAddActorMutation,
	useGetBookDetailsQuery,
	useUpdateAdminBookMutation,
	useAddAdminBookMutation,
} from '../../../store/apiSlice';
import {VirtualizeControlled} from '../../../components/Virtualize';
import { useForm, Controller } from 'react-hook-form';
// popup
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Const from '../../../defs/const';

const useStyles = makeStyles((theme) => ({
	root: {
		display: 'flex',
		alignItems: 'center',
	},
	mt2: {
		marginTop: theme.spacing(2),
	},
	container: {
		paddingTop: theme.spacing(4),
		paddingBottom: theme.spacing(4),
	},
	paper: {
		padding: theme.spacing(2),
	},
	title: {
		paddingBottom: theme.spacing(2),
	},
	backButton: {
		marginBottom: theme.spacing(2),
	},
	flex: {
		display: 'flex',
		gap: 24,
		alignItems: 'center',
		justifyContent: 'center',
	},
}));

export function CatalogueCreate(props) {
	const classes = useStyles();
	const navigate = useNavigate();
	const { id } = useParams();
	const { data, currentData, isFetching } = useGetBookDetailsQuery(id);
	const [filesData, setFilesData] = useState(data?.files);

	useEffect(() => {
		setFilesData(data?.files);
	}, [data]);

	console.log(data, currentData, isFetching);

	const [name, setName] = useState(); // name for newly added entry

	const [addActor] = useAddActorMutation();
	const [addCategory] = useAddCategoryMutation();
	const [addAuthor] = useAddAuthorMutation();

	const [updateBook] = useUpdateAdminBookMutation();
	const [addAdminBook] = useAddAdminBookMutation(); // RTK Query mutation

	// popup state
	const [open, setOpen] = useState(false);
	const [popUpType, setPopUpType] = useState('');
	const [fileUploadError, setFileUploadError] = useState('');
	const [submitError, setSubmitError] = useState('');

	const handleCreateEntry = () => {
		if (popUpType === 'actor') {
			addActor({ name });
		} else if (popUpType === 'author') {
			addAuthor({ name });
		} else if (popUpType === 'category') {
			addCategory({ name });
		} else {
			console.error('No such entry type.');
		}
		setOpen(false);
	};

	const handleClose = () => {
		setName('');
		setOpen(false);
	};

	const { data: authors = [] } = useGetAuthorsQuery();
	const { data: actors = [] } = useGetActorsQuery();
	const { data: categories = [] } = useGetCategoriesQuery();

	const {
		handleSubmit,
		control,
		setValue,
		reset,
		trigger,
		formState: { errors },
	} = useForm({
		defaultValues: {
			title: '',
			author: '',
			category: '',
			year: '',
			actor: '',
			identifier: '',
			len: '',
			newFiles: null, // file input field
			files: '',
		},
	});

	useEffect(() => {
		const book = data?.book;
		if (book) {
			reset({
				title: book.title,
				author: book.author?.id,
				category: book.category?.id,
				year: book.year,
				actor: book.actor?.id,
				identifier: book?.code,
				len: book.duration,
			});
		}
	}, [data, reset]);

	const onSubmit = async (values) => {
		console.log('Form Submitted. VALUES:', values);
		setSubmitError('');

		if (values.newFiles && values.newFiles.length > Const.MAX_BOOK_UPLOAD_FILES) {
			const errorMessage = `Може да качите най-много ${Const.MAX_BOOK_UPLOAD_FILES} файла наведнъж.`;
			setFileUploadError(errorMessage);
			setSubmitError(errorMessage);
			return;
		}
		setFileUploadError('');

		// Create FormData for multipart/form-data submission
		const formData = new FormData();
		formData.append('title', values.title);
		formData.append('author', values.author);
		formData.append('category', values.category);
		formData.append('year', values.year);
		formData.append('actor', values.actor);
		formData.append('identifier', values.identifier);
		formData.append('len', values.len);

		// Append each file from the newFiles field
		if (values.newFiles && values.newFiles.length > 0) {
			for (let i = 0; i < values.newFiles.length; i++) {
				formData.append('newFiles', values.newFiles[i]);
			}
		}

		try {
			// Use the RTK Query mutation to add the book
			const result = await addAdminBook(formData).unwrap();
			console.log('Response:', result);
			// Optionally navigate to another page on success
			navigate('/admin/catalogue');
		} catch (error) {
			console.error('Error adding book:', error);
			setSubmitError(
				error?.data?.message ||
					error?.data?.error ||
					'Грешка при качването на файловете или създаването на книгата.'
			);
		}
	};

	return (
		<div className={classes.root}>
			<CssBaseline />
			<Helmet>
				<title>Добавяне на книга</title>
			</Helmet>

			<Container maxWidth="lg" className={classes.container}>
				<Paper className={classes.paper}>
					<Typography
						className={classes.title}
						component="h1"
						variant="h4"
						role="alert"
					>
						Добавяне на книга
					</Typography>

					<form onSubmit={handleSubmit(onSubmit)}>
						<Grid
							container
							spacing={1}
							justifyContent="flex-start"
							alignItems="flex-start"
							direction="row"
						>
							<Grid item xs={12}>
								<Controller
									name="title"
									control={control}
									rules={{
										required: { value: true, message: 'Задължително поле' },
									}}
									render={({ field }) => (
										<TextField
											label="Заглавие"
											fullWidth
											error={!!errors.title}
											helperText={errors?.title?.message}
											id="title"
											{...field}
										/>
									)}
								/>
							</Grid>
							<Grid item xs={12}>
								<VirtualizeControlled
									label="Автор"
									id="author_id"
									options={[{ name: '------------' }, ...authors]}
									handleChange={(e, options) => {
										setValue('author', options?.id);
									}}
									control={control}
									error={!!errors.author}
									helperText={errors?.author?.message}
									rules={{
										required: { value: true, message: 'Задължително поле' },
									}}
									name="author"
									defaultValue={{
										name: data?.book?.author?.name || 'Няма',
										id: parseInt(data?.book?.author?.id, 10),
									}}
								/>
								<Button
									startIcon={<AddIcon />}
									onClick={() => {
										setOpen(true);
										setPopUpType('author');
									}}
								>
									Добави автор
								</Button>
							</Grid>
							<Grid item xs={12}>
								<VirtualizeControlled
									label="Категория"
									id="category"
									options={[{ name: '------------' }, ...categories]}
									handleChange={(e, options) =>
										setValue('category', options?.id)
									}
									control={control}
									error={!!errors.category}
									helperText={errors?.category?.message}
									rules={{
										required: { value: true, message: 'Задължително поле' },
									}}
									name="category"
									defaultValue={{
										name: data?.book?.category?.name || 'Няма',
										id: parseInt(data?.book?.category?.id, 10),
									}}
								/>
								<Button
									startIcon={<AddIcon />}
									onClick={() => {
										setOpen(true);
										setPopUpType('category');
									}}
								>
									Добави категория
								</Button>
							</Grid>
							<Grid item xs={12}>
								<Controller
									name="year"
									control={control}
									rules={{
										required: { value: true, message: 'Задължително поле' },
										onChange: () => {
											trigger('year');
										},
									}}
									render={({ field }) => (
										<TextField
											label="Година"
											fullWidth
											type="number"
											error={!!errors.year}
											helperText={errors?.year?.message}
											id="year"
											{...field}
										/>
									)}
								/>
							</Grid>
							<Grid item xs={12}>
								<VirtualizeControlled
									label="Актьор"
									id="actor"
									options={[{ name: '------------' }, ...actors]}
									handleChange={(e, options) => setValue('actor', options?.id)}
									control={control}
									error={!!errors.actor}
									helperText={errors?.actor?.message}
									rules={{
										required: { value: true, message: 'Задължително поле' },
									}}
									name="actor"
									defaultValue={{
										name: data?.book?.actor?.name || 'Няма',
										id: parseInt(data?.book?.actor?.id, 10),
									}}
								/>
								<Button
									startIcon={<AddIcon />}
									onClick={() => {
										setOpen(true);
										setPopUpType('actor');
									}}
								>
									Добави актьор
								</Button>
							</Grid>
							<Grid item xs={12}>
								<Controller
									name="identifier"
									control={control}
									rules={{
										required: { value: true, message: 'Задължително поле' },
									}}
									render={({ field }) => (
										<TextField
											label="Идентификатор"
											fullWidth
											error={!!errors.identifier}
											helperText={errors?.identifier?.message}
											id="identifier"
											{...field}
										/>
									)}
								/>
							</Grid>
							<Grid item xs={12}>
								<Controller
									name="len"
									control={control}
									rules={{
										required: { value: true, message: 'Задължително поле' },
									}}
									render={({ field }) => (
										<TextField
											label="Продължителност"
											fullWidth
											error={!!errors.len}
											helperText={errors?.len?.message}
											id="len"
											{...field}
										/>
									)}
								/>
							</Grid>
							<Grid item xs={12}>
								<div className={classes.flex}>
									<Typography>Файлове</Typography>
								</div>
							</Grid>
						</Grid>
						<List>
							{filesData?.map((file) => (
								<ListItem key={file.id}>
									<ListItemText>{file.name}</ListItemText>
									<ListItemSecondaryAction>
										<Button
											onClick={() => {
												setFilesData((prevState) =>
													prevState.filter((f) => f.id !== file.id)
												);
											}}
											startIcon={<DeleteIcon />}
										>
											Изтрий
										</Button>
									</ListItemSecondaryAction>
								</ListItem>
							))}
						</List>
						{/* New file input field */}
						<Grid item xs={12} className={classes.mt2}>
							<Controller
								name="newFiles"
								control={control}
								render={({ field }) => (
									<input
										type="file"
										multiple
										onChange={(e) => {
											const files = e.target.files;
											if (
												files &&
												files.length > Const.MAX_BOOK_UPLOAD_FILES
											) {
												setFileUploadError(
													`Може да качите най-много ${Const.MAX_BOOK_UPLOAD_FILES} файла наведнъж.`
												);
											} else {
												setFileUploadError('');
											}
											field.onChange(files);
										}}
									/>
								)}
							/>
							<Typography variant="body2" color="textSecondary">
								Максимум {Const.MAX_BOOK_UPLOAD_FILES} файла наведнъж.
							</Typography>
							{fileUploadError ? (
								<Typography variant="body2" color="error">
									{fileUploadError}
								</Typography>
							) : null}
						</Grid>
						<br />
						{submitError ? (
							<Typography variant="body2" color="error" className={classes.mt2}>
								{submitError}
							</Typography>
						) : null}
						<Button
							type="submit"
							startIcon={<DoneIcon />}
							className={classes.mt2}
						>
							Запис
						</Button>
					</form>
				</Paper>
			</Container>
			<Dialog
				open={open}
				onClose={handleClose}
				aria-labelledby="form-dialog-title"
			>
				{popUpType === 'author' ? (
					<DialogTitle id="form-dialog-title">Добави автор</DialogTitle>
				) : popUpType === 'category' ? (
					<DialogTitle id="form-dialog-title">Добави категория</DialogTitle>
				) : popUpType === 'actor' ? (
					<DialogTitle id="form-dialog-title">Добави актьор</DialogTitle>
				) : (
					<DialogTitle id="form-dialog-title">Invalid</DialogTitle>
				)}
				<DialogContent>
					<TextField
						autoFocus
						margin="dense"
						id={popUpType}
						label="Име"
						type="text"
						fullWidth
						value={name}
						onChange={(e) => setName(e.target.value)}
					/>
				</DialogContent>
				<DialogActions>
					<Button
						onClick={handleCreateEntry}
						startIcon={<AddIcon />}
						color="primary"
					>
						Запис
					</Button>
					<Button onClick={handleClose} color="primary">
						Отказ
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	);
}
